import React from 'react';
import PropTypes from 'prop-types';

export const Section = ({ children, heading, hasBackground }) => (
  <div
    className="section"
    style={{
      background: hasBackground ? '#f3f3f3' : '#fff',
      textAlign: 'center',
    }}
  >
    <div className="container">
      <h3 className="title is-3">{heading}</h3>
      {children}
    </div>
  </div>
);

Section.propTypes = {
  heading: PropTypes.string,
  hasBackground: PropTypes.bool,
};
